import $ from 'jquery';
import BaseView from '../../core/baseView';
import AddressCheckViewController from '../../helpers/addressCheck/addressCheckViewController';
import * as lightbox from '../../../home24/helpers/lightbox';

export default BaseView.extend({
    events: {
        'click .js-open-registration': 'showRegisterForm',
        'click .js-forgot-password': 'onForgotPasswordClick'
    },

    selectors: {
        blockIntro: '#checkout-registration-block-intro',
        blockFull: '#checkout-registration-block-full',
        lightboxDialogForgotPassword: '#myaccount-forgot-pswd'
    },

    lightboxConfig: {
        $dialog: null,
        className: 'myaccount-password-lightbox-spacer'
    },

    initialize: function (options) {
        /* istanbul ignore else */
        if (options.scope) {
            this.$scope = options.scope;
        } else {
            this.$scope = $('body');
        }
    },

    showRegisterForm: function () {
        new AddressCheckViewController({
            el: $('#view2'),
            scope: this.$scope
        });

        new AddressCheckViewController({
            el: $('#view3'),
            scope: this.$scope
        });

        this.$(this.selectors.blockIntro).addClass('is-hidden');
        this.$(this.selectors.blockFull).removeClass('is-hidden');
    },

    onForgotPasswordClick: function (event) {
        event.preventDefault();

        this.lightboxConfig.$dialog = this.$scope.find(this.selectors.lightboxDialogForgotPassword);

        /* istanbul ignore else */
        if (this.lightboxConfig.$dialog.length > 0) {

            lightbox.setConfig(this.lightboxConfig);
            lightbox.open();
        }
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/loginView.js
 **/